import React, { FC } from "react";
import styles from "./NotFoundPage.module.scss";

interface NotFoundPageProps {}

const NotFoundPage: FC<NotFoundPageProps> = () => (
	<div className={styles.NotFoundPage}>
		<div className="wraper">
			<div className="title">
				4
				<span role="img" aria-label="Crying Face">
					😢
				</span>
				4
			</div>
      <p className="message"></p>
		</div>
	</div>
);

export default NotFoundPage;

